// @ts-strict-ignore
import { createSelector } from 'reselect';
import type { State } from '~/store';
import type { Application, ApplicationPageState } from './types';

export const selectApplicationPage = (state: State): ApplicationPageState => state.applicationPage;

export const selectApplication = (state: State): Application | undefined => (
  state.applicationPage?.application
);

export const selectCompletedReviews = (state: State) => ({
  alertManualReviews: state.applicationPage
    ?.completedAlertManualReviewsByAlertManualReviewToken || {},
  cases: state.applicationPage?.completedCasesByCaseToken || {},
});

export const selectTestToken = createSelector([selectApplication], application => {
  if (!application) return undefined;
  const {
    multiEnvironmentConfigToken,
    sandboxPersonaTestToken,
    shadowTestToken,
  } = application;
  return multiEnvironmentConfigToken || sandboxPersonaTestToken || shadowTestToken;
});

export const selectIsTestApplication = createSelector([selectApplication], application => {
  if (!application) return false;
  const {
    sandboxPersonaTestToken,
    isShadowApplication,
    multiEnvironmentConfigToken,
  } = application;
  return Boolean(sandboxPersonaTestToken || isShadowApplication || multiEnvironmentConfigToken);
});

export const selectApplicationDocumentTypes = (state: State) => (
  state.applicationPage?.documentTypes || []
);
